import { Tenant } from '@models/tenant.model';
 
import api from '../api/instance';

const nameSpace = '/tenants';

const show = (id: number) => {
  return api
    .get(`${nameSpace}/${id}`)
    .then(
      (res) => new Tenant().deserialize(res),
      (error) => {},
    )
    .catch((e) => Promise.reject(e));
};

const update = (id: number, formData) => {
  return api
    .put(`${nameSpace}/${id}`, formData, null, 'multipart/form-data')
    .then(
      (res) => new Tenant().deserialize(res),
      (error) => {},
    )
    .catch((e) => Promise.reject(e));
};

export const TenantService = {
  show,
  update,
};
